import { Utility } from '../utility/utility_controller'

// max width for site title and menu

// when "misc options" -> "apply max width of content to logo and menu" is activated

var maxwidth_controller = {
	i: function () {
		i()
	},
}

export default maxwidth_controller

var maxwidth = 0

var jqueryMap = {
	$body: null,
	$nav: null,
	$st: null,
	$burger: null,
}

var setJqueryMap = function () {
	jqueryMap.$body = jQuery('body')
	jqueryMap.$nav = jQuery('nav.primary')
	jqueryMap.$nav2 = jQuery('nav.second_menu')
	jqueryMap.$nav3 = jQuery('nav.third_menu')
	jqueryMap.$nav4 = jQuery('nav.fourth_menu')

	jqueryMap.$st = jQuery('.sitetitle')
	jqueryMap.$burger = jQuery('.overlay-burger')
}

var init = function () {
	maxwidth = parseInt(layData.maxwidth, 10)
	setJqueryMap()
	bindResize()
	positionNavAndSt()
}

var bindResize = function () {
	jQuery(window).on('window_width_changed', positionNavAndSt)
}

var positionNavAndSt = function () {
	var bodyWidth = jqueryMap.$body.innerWidth()
	var nav_props = layData.nav_customizer_properties

	var frame_left = parseFloat(layData.frame_left)
	var frame_right = parseFloat(layData.frame_right)

	if (layData.frame_leftright_mu == '%') {
		frame_left = (maxwidth / 100) * frame_left
		frame_right = (maxwidth / 100) * frame_right
	}

	if (bodyWidth > maxwidth && Utility.isDesktopOrTabletSize) {
		var leftSpace = (bodyWidth - maxwidth) / 2 + frame_left
		var rightSpace = (bodyWidth - maxwidth) / 2 + frame_right

		if (layData.st_position.indexOf('left') != -1) {
			jqueryMap.$st.css('left', leftSpace + 'px')
		} else if (layData.st_position.indexOf('right') != -1) {
			jqueryMap.$st.css('right', rightSpace + 'px')
		}

		// menu amt: 1
		if (nav_props.nav_position.indexOf('left') != -1) {
			jqueryMap.$nav.css('left', leftSpace + 'px')
		} else if (nav_props.nav_position.indexOf('right') != -1) {
			jqueryMap.$nav.css('right', rightSpace + 'px')
		}
		// 2
		if (layData.nav_amount >= 2) {
			if (nav_props.nav_position_second_menu.indexOf('left') != -1) {
				jqueryMap.$nav2.css('left', leftSpace + 'px')
			} else if (nav_props.nav_position_second_menu.indexOf('right') != -1) {
				jqueryMap.$nav2.css('right', rightSpace + 'px')
			}
		}
		// 3
		if (layData.nav_amount >= 3) {
			if (nav_props.nav_position_third_menu.indexOf('left') != -1) {
				jqueryMap.$nav3.css('left', leftSpace + 'px')
			} else if (nav_props.nav_position_third_menu.indexOf('right') != -1) {
				jqueryMap.$nav3.css('right', rightSpace + 'px')
			}
		}
		// 4
		if (layData.nav_amount >= 4) {
			if (nav_props.nav_position_fourth_menu.indexOf('left') != -1) {
				jqueryMap.$nav4.css('left', leftSpace + 'px')
			} else if (nav_props.nav_position_fourth_menu.indexOf('right') != -1) {
				jqueryMap.$nav4.css('right', rightSpace + 'px')
			}
		}

		// burger icon
		if (layData.misc_options_max_width_apply_to_burger == 'on') {
			jqueryMap.$burger.each(function () {
				var $burger = jQuery(this)
				// Check computed style to determine if burger is on left or right
				// Burgers are positioned with either left:0 or right:0 in inline styles
				var computedLeft = $burger.css('left')
				var computedRight = $burger.css('right')

				// If left is 0px (or very close), it's positioned on the left
				if (computedLeft && computedLeft !== 'auto' && parseFloat(computedLeft) === 0) {
					$burger.css('left', leftSpace + 'px')
					$burger.css('padding-left', '0')
				}
				// If right is 0px (or very close), it's positioned on the right
				else if (computedRight && computedRight !== 'auto' && parseFloat(computedRight) === 0) {
					$burger.css('right', rightSpace + 'px')
					$burger.css('padding-right', '0')
				}
			})
		}
	} else {
		// get rid of styles
		if (layData.st_position.indexOf('left') != -1) {
			jqueryMap.$st.css('left', '')
		} else if (layData.st_position.indexOf('right') != -1) {
			jqueryMap.$st.css('right', '')
		}

		// menu amt: 1
		if (nav_props.nav_position.indexOf('left') != -1) {
			jqueryMap.$nav.css('left', '')
		} else if (nav_props.nav_position.indexOf('right') != -1) {
			jqueryMap.$nav.css('right', '')
		}
		// 2
		if (layData.nav_amount >= 2) {
			if (nav_props.nav_position_second_menu.indexOf('left') != -1) {
				jqueryMap.$nav2.css('left', '')
			} else if (nav_props.nav_position_second_menu.indexOf('right') != -1) {
				jqueryMap.$nav2.css('right', '')
			}
		}
		// 3
		if (layData.nav_amount >= 3) {
			if (nav_props.nav_position_third_menu.indexOf('left') != -1) {
				jqueryMap.$nav3.css('left', '')
			} else if (nav_props.nav_position_third_menu.indexOf('right') != -1) {
				jqueryMap.$nav3.css('right', '')
			}
		}
		// 4
		if (layData.nav_amount >= 4) {
			if (nav_props.nav_position_fourth_menu.indexOf('left') != -1) {
				jqueryMap.$nav4.css('left', '')
			} else if (nav_props.nav_position_fourth_menu.indexOf('right') != -1) {
				jqueryMap.$nav4.css('right', '')
			}
		}

		// burger icon - reset to original position (0)
		if (layData.misc_options_max_width_apply_to_burger == 'on') {
			jqueryMap.$burger.each(function () {
				var $burger = jQuery(this)
				// Reset to 0 (original inline style position)
				// Check if left or right was set to determine which to reset
				var computedLeft = $burger.css('left')
				var computedRight = $burger.css('right')

				// If left was used (and is not 0 or auto), reset it and restore padding
				if (computedLeft && computedLeft !== 'auto' && computedLeft !== '0px') {
					$burger.css('left', '0')
					$burger.css('padding-left', '')
				}
				// If right was used (and is not 0 or auto), reset it and restore padding
				if (computedRight && computedRight !== 'auto' && computedRight !== '0px') {
					$burger.css('right', '0')
					$burger.css('padding-right', '')
				}
			})
		}
	}
}

var i = function () {
	if ((layData.misc_options_max_width_apply_to_logo_and_nav == 'on' || layData.misc_options_max_width_apply_to_burger == 'on') && layData.maxwidth != 0) {
		init()
	}
}
